import React from 'react'
import { Grid, Typography } from '@mui/material'
import Logo from './Logo'
import Navigation from './Navigation'
import Newsletters from './Newsletters'
import i18next from 'i18next'

const Footer = () => {
    let lng = i18next.language
    const currentYear = new Date().getFullYear();
    return (
        <>
            <footer>
                {/* <div className="overlay"></div> */}
                <Grid container sx={{textAlign:{md:'unset', xs:'center'}}} >
                    <Grid item md={3} xs={12}  sx={{display:'flex', justifyContent:{md:'center',xs:'center'}}} >
                        <Newsletters />
                    </Grid>
                    <Grid item md={6} xs={12} sx={{display:'flex', justifyContent:{md:'center',xs:'center'}}} >
                        <Navigation />
                    </Grid>
                    <Grid item md={3} xs={12} sx={{display:'flex', justifyContent:{md:'center',xs:'center'}}} >
                        <Logo />
                    </Grid>
                </Grid>
                <Typography color='primary.text' variant={'body2'} fontWeight={200}
                    sx={{ position: 'relative', zIndex: 3, textAlign: 'center', my: 1 }} >
                    <bdi>{lng === 'ar' ? ` جميع الحقوق محفوظة` : 'All rights reserved '} {currentYear}</bdi> 
                    <a href="https://smartclick.marketing" target="_blank" style={{ textDecoration: 'none', color: 'inherit' }}
                        rel="noopener noreferrer"> Smart Click </a> 
                </Typography>
                {lng === 'ar' ?
                    <Typography color='primary.text' variant={'body2'} fontWeight={200}
                        sx={{ position: 'relative', zIndex: 3, textAlign: 'center', my: 1 }} >
                        تصميم وتطوير شركة <a style={{ color: '#fff', textDecoration: 'none' }} href="https://smartclick.marketing" target="_blank" rel="noopener noreferrer">Smart Click</a>
                    </Typography> : <Typography color='primary.text' variant={'body2'} fontWeight={200}
                        sx={{ position: 'relative', zIndex: 3, textAlign: 'center', my: 1 }} >
                        Design and development company <a style={{ color: '#fff', textDecoration: 'none' }} href="https://smartclick.marketing" target="_blank" rel="noopener noreferrer">Smart Click</a>
                    </Typography>}
            </footer>
        </>
    )
}

export default Footer